import React from 'react'
import Page from 'layout/access-management/page'
import PageTitle from 'layout/page-title'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import OverviewTab from './overview'

function Duties() {
  return (
    <Page title={'Access Management'}>
      <PageTitle />

      <Row>
        <Col sm={12}>
          <OverviewTab />
        </Col>
      </Row>
    </Page>
  )
}

export default Duties
